import { useLayoutEffect, useRef, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { IObject } from 'types';
import { Coords } from 'components/fias/fias-search/types';
import { useCloseMenuOnScroll } from 'components/fias/fias-search/utils';
import {
  MenuWrapper,
  OptionWrapper,
  ScrollWrapper,
  Text,
} from './address-item-menu.styled';

interface IProps {
  item: IObject;
  coords: Coords;
  closePortal: () => void;
  menuWidth: number | null;
}

export const AddressItemMenu = observer(
  ({ item, coords, menuWidth, closePortal }: IProps) => {
    const menuRef = useRef<HTMLDivElement>(null);
    const [height, setHeight] = useState<number>(0);
    useCloseMenuOnScroll(menuRef, () => closePortal());

    useLayoutEffect(() => {
      if (menuRef.current) {
        setHeight(menuRef.current.clientHeight);
      }
    }, []);

    return (
      <MenuWrapper coords={coords} ref={menuRef} height={height}>
        <ScrollWrapper menuWidth={menuWidth}>
          {/* Объект, выбранный целиком, приходит без selectedHouses */}
          {(item.selectedHouses ?? item.houses ?? []).map(
            (house: IObject, index: number) => (
              <OptionWrapper key={index}>
                <Text>{house.short_address}</Text>
              </OptionWrapper>
            )
          )}
        </ScrollWrapper>
      </MenuWrapper>
    );
  }
);
